<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('app_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.add_org_cname" :placeholder="$t('code_cname')">
                        <span slot="prepend">{{$t('app_org')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.org_cname" :placeholder="$t('code_cname')">
                        <span slot="prepend">{{$t('org')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" style="width: 100%" height="100%">
                    <el-table-column fixed :label="$t('logo_img')" width="80px">
                        <template slot-scope="scope">
                            <myImgshow :src="scope.row.img_lnk" @onClick="$base.alertImg(scope.row.img_lnk, scope.row.org_cname)"></myImgshow>
                        </template>
                    </el-table-column>
                    <el-table-column fixed prop="org_code" :label="listHeader.org_code" width="100px"></el-table-column>
                    <el-table-column fixed prop="org_cname" :label="listHeader.org_cname" width="120px"></el-table-column>
                    <el-table-column prop="add_org_cname" :label="listHeader.add_org_cname" width="120px"></el-table-column>
                    <el-table-column prop="app_time" :label="listHeader.app_time" width="140px"></el-table-column>
                    <el-table-column width="120px" prop="mod_cname">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.mod_cname" :list="mods" v-model="search.mod_id"
                                        title_class="f12 f-blue" key_name="mod_cname" value_name="mod_id" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px" prop="join_type_cname">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.join_type_cname" :list="join_type" v-model="search.join_type"
                                        title_class="f12 f-blue" key_name="type_cname" value_name="join_type" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fee_cat_cname" :label="listHeader.fee_cat_cname" width="100px"></el-table-column>
                    <el-table-column :label="listHeader.fee_amt" width="80px">
                        <template slot-scope="scope">{{scope.row.fee_amt}}{{$t('price_unit')}}</template>
                    </el-table-column>
                    <el-table-column prop="link_cname" :label="listHeader.link_cname" width="80px"></el-table-column>
                    <el-table-column prop="link_mobile" :label="listHeader.link_mobile" width="110px"></el-table-column>
                    <el-table-column :label="listHeader.addr" min-width="160px">
                        <template slot-scope="scope">{{scope.row.prov}}{{scope.row.city}}{{scope.row.area}}{{scope.row.addr}}</template>
                    </el-table-column>
                    <el-table-column prop="org_admin_code" :label="listHeader.org_admin_code" width="120px"></el-table-column>
                    <el-table-column fixed="right" :label="$t('op')" width="60px">
                        <template slot-scope="scope">
                            <a class="link" @click="openSave(scope.row.app_id)">{{$t('info')}}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDropdown from '../../../components/myDropdown'
    import myDatePicker from '../../../components/myDatePicker'
    import myImgshow from '../../../components/myImgshow'
    export default {
        name:"rw-orgapp",
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker,
            myImgshow
        },
        data:function(){
            const listHeader = {
                img_lnk: this.$t('logo_img'),
                org_code: this.$t('org_code'),
                org_cname: this.$t('org_cname'),
                add_org_cname: this.$t('app_org'),
                app_time: this.$t('app_time'),
                mod_cname: this.$t('org_mod_cname'),
                join_type_cname: this.$t('join_type_cname'),
                fee_cat_cname: this.$t('fee_cat'),
                fee_amt: this.$t('fee'),
                link_cname: this.$t('link_cname'),
                link_mobile: this.$t('link_mobile'),
                addr: this.$t('addr'),
                org_admin_code: this.$t('org_admin_code'),
                listHeaderEx:{
                    img_lnk: {type:'image',width:120,height:120}
                }
            };
            return{
                show_subview:false,
                relist:false,
                search:{
                    search_url: "rw-orgapp/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    add_org_cname: '',
                    org_cname: '',
                    mod_id: '',
                    join_type: ''
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                mods:[
                    {
                        mod_id:'',
                        mod_cname:this.$t('all')
                    }
                ],
                join_type:[
                    {
                        join_type:'',
                        type_cname:this.$t('all')
                    }
                ],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();

            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function() {
                var data = {};
                this.$base.showLoading();
                this.$request.sendPost("rw-orgapp/before-list",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = this.mods.concat(data.mods);
                        this.join_type = this.join_type.concat(data.join_type);
                        this.list();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function() {
                this.$base.exportExcel(this);
            },
            openSave:function (id) {
                this.$base.linkTo('orgapp/save', {id});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/rw/orgapp/list.vue